// 鉴权指令
import directiveAuth from './auth'

export default {
    install (Vue, options) {
        // 指令
        Vue.directive('auth', directiveAuth)
    }
}
